var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tags"},_vm._l((_vm.tagsItems),function(tagsItem){return _c('li',{staticClass:"tags__item",class:{_active: tagsItem.tagActive}},[_vm._v("\n        "+_vm._s(tagsItem.name)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }